// 這邊以後可以客製化樣板相關顏色 需要設計配置制定規範

const Themes = {
  themes1: {
    contentBox: "rgba(0,0,0,0.83)",
    color: "#fff",
    headerbg: "#000",
    marqueebg: "#454545",
    title: "#cec074",
    count001: "linear-gradient(to bottom, #404040, #000)",
    countBox001: "linear-gradient(180deg,#867c42,#f8e98f 54%,#6f673e)",
    footerBox: "#272727",
    copyrightBG: "#464646"
  }
};

export default Themes
